import { FC } from 'react'
import { ErrorMessage } from '@hookform/error-message'
// import { FieldErrorsImpl } from 'react-hook-form';

interface LoginFormErrorProps {
	// fieldErrors: FieldErrorsImpl<{
	// 	[x: string]: any;
	// }>
	fieldErrors: any
	inputName: string
}

const LoginFormError: FC<LoginFormErrorProps> = ({
	fieldErrors,
	inputName,
}) => {
	return (
		<ErrorMessage
			errors={fieldErrors}
			name={inputName}
			render={({ message }) => (
				<small className="p-error block">
					{message}
				</small>
			)}
		/>
	)
}

export default LoginFormError